module.exports = __webpack_public_path__ + "img/hints.135d0ab8.svg";